/* ==========================================================================
   Glasshaus · image protection

   Deters casual copying of campaign and product imagery:
     - suppresses the right-click context menu
     - blocks drag-to-desktop on images
     - blocks the iOS long-press "Save Image" callout

   This is a deterrent, not security. Anyone can still reach the files via
   devtools, view-source, or the Shopify CDN URL directly, and disabling
   JavaScript removes it entirely. Real protection would mean watermarking
   or serving lower-resolution originals.

   Deliberately inert inside the theme editor so merchandising work is not
   hampered while editing.
   ========================================================================== */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var block = function (e) {
    e.preventDefault();
    return false;
  };

  // 1. right-click anywhere on the storefront
  document.addEventListener('contextmenu', block);

  // 2. dragging an image out of the page
  document.addEventListener('dragstart', function (e) {
    var t = e.target;
    if (t && (t.tagName === 'IMG' || t.tagName === 'PICTURE' || t.closest('picture, svg'))) {
      return block(e);
    }
  });

  // 3. long-press save sheet on touch devices
  document.addEventListener(
    'touchstart',
    function (e) {
      if (e.target && e.target.tagName === 'IMG') e.target.style.webkitTouchCallout = 'none';
    },
    { passive: true }
  );
})();
